<template>
    <div>

        <div class="bg-white shadow-lines sm:shadow-dreamy">

            <a id="step-card-payment" class="flex px-8 py-8 justify-between items-center" href="" @click.prevent="stepChange">
                <span class="w-8 mr-8">
                    <svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="14.5" stroke="#4A96D2"/><path d="M20.02 18.06v-2.4h-1.48v-7.5H15.8l-5.92 7.6v2.3h5.94V22h2.72v-3.94h1.48zm-4.2-6.32v3.92h-3.08l3.08-3.92z" fill="#4A96D2"/></svg>
                </span>
                <span
                    :class="{ 'text-gray-300': disabled, 'text-black': !disabled }"
                    class="w-full text-xl font-platform tracking-wider"
                >Välj betalsätt</span>
            </a>

            <!-- Expanded -->
            <div class="pb-4 px-4 sm:pb-8 sm:px-8" v-if="open && ! loading">

                <div class="text-lg text-blue-400 mb-2">Summa</div>
                <div class="text-base mb-6">{{ form.amount }} kr</div>

                <div class="text-lg text-blue-400 mb-2">Kontaktuppgifter</div>
                <template v-if="form.contact.skip_national_identification_number">
                    <div class="text-base mb-1">{{ form.contact.first_name }} {{ form.contact.last_name }}</div>
                    <div class="text-base mb-1">{{ form.contact.line1 }}</div>
                    <div class="text-base mb-1">{{ form.contact.zip }} {{ form.contact.city }}</div>
                </template>
                <template v-else>
                    <div class="text-base mb-1">{{ form.contact.national_identification_number }}</div>
                </template>

                <div class="text-base mb-1">{{ form.contact.email }}</div>
                <div class="text-base mb-6">{{ form.contact.phone }}</div>

                <template v-if="form.delivery.method === 'print'">
                    <div class="text-lg text-blue-400 mb-2 mt-6">
                        <template v-if="product.type === 'memorial_card'">Ditt minnesblad kommer att skickas till</template>
                        <template v-else-if="product.type === 'honor_card'">Ditt gåvoblad kommer att skickas till</template>
                        <template v-else>Leverans</template>
                    </div>
                    <template v-if="form.delivery.funeral_at">
                        <div class="text-base mb-1">Begravningsdatum: {{ form.delivery.funeral_at | dateHuman }}</div>
                    </template>

                    <template v-if="form.delivery.location === 'funeral_home'">
                        <div class="text-base mb-1">{{ form.delivery.funeral_home }}</div>
                        <div class="text-base mb-1">{{ form.delivery.line1 }}</div>
                        <div class="text-base mb-1">{{ form.delivery.zip }} {{ form.delivery.city }}</div>
                    </template>
                    <template v-if="form.delivery.location === 'address'">
                        <div class="text-base mb-1">{{ form.delivery.to }}</div>
                        <div class="text-base mb-1">{{ form.delivery.line1 }}</div>
                        <div class="text-base mb-1">{{ form.delivery.zip }} {{ form.delivery.city }}</div>
                    </template>
                    <template v-if="form.delivery.location === 'home'">
                        <template v-if="form.contact.skip_national_identification_number">
                            <div class="text-base mb-1">{{ form.contact.first_name }} {{ form.contact.last_name }}</div>
                            <div class="text-base mb-1">{{ form.contact.line1 }}</div>
                            <div class="text-base mb-1">{{ form.contact.zip }} {{ form.contact.city }}</div>
                        </template>
                        <template v-else>
                            <div class="text-base mb-1">Din folkbokföringsadress ({{ form.contact.national_identification_number }})</div>
                        </template>
                    </template>
                </template>



                <div class="text-lg text-blue-400 mb-3 mt-6">Välj hur du vill betala</div>


                <template v-if="paymentBootComplete">
                    <OrangePayment
                        :api="paymentApi"
                        :name="`${form.contact.first_name} ${form.contact.last_name}`"
                        :order-id="orderId"
                        @success="next"
                        :success-url="successUrlDecorated"
                    ></OrangePayment>
                </template>
                <template v-else>
                    <card-spinner color="#1D5091"></card-spinner>
                </template>

            </div>
        </div>

    </div>
</template>

<script>
    import OrangePayment from './OrangePayment'
    import axios from 'axios'
    import Helpers from '../helpers'
    import CardSpinner from './CardSpinner'

    export default {
        name: "CardPayment",
        components: {CardSpinner, OrangePayment},
        mixins: [Helpers],
        props: {
            open: {type: Boolean, default: false},
            loading: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
            successUrl: null,
            product: {},
            form: {},
        },
        data() {
            return {
                paymentBootComplete: false,
                orderId: null,
                paymentApi: `${process.env.VUE_APP_PAYMENT_BACKEND}/${this.$route.params.accountId}`,
                successUrlDecorated: null,
            }
        },
        filters: {
            dateHuman(value) {
                let date = new Date(value)
                let year = new Intl.DateTimeFormat('sv', { year: 'numeric' }).format(date)
                let month = new Intl.DateTimeFormat('sv', { month: 'short' }).format(date)
                let day = new Intl.DateTimeFormat('sv', { day: '2-digit' }).format(date)

                return `${day} ${month} ${year}`
            }
        },
        methods: {
            async boot() {
                let response = await axios.post(this.api(`/${this.$route.params.accountId}/${this.form.id}/order`))
                this.orderId = response.data.order_id

                let orderSuccessUrlResponse = await axios.get(this.api(`/${this.$route.params.accountId}/${this.form.id}/order/${this.orderId}/success-url?url=${this.successUrl}`))
                this.successUrlDecorated = orderSuccessUrlResponse.data.success_url

                this.paymentBootComplete = true
            },
            stepChange() {
                if (!this.disabled) {
                    this.paymentBootComplete = false
                    this.$emit('step', 'card-payment')
                }
            },
            next() {
                this.$emit('completed', {
                    step: 'card-payment',
                    orderId: this.orderId,
                })
            }
        }
    }
</script>